export const INSTITUTION_CONSTRAINTS = {
  ADD_INSTITUTION_CONSTRAINT: 'ADD_INSTITUTION_CONSTRAINT',
  DELETE_INSTITUTION_CONSTRAINT: 'DELETE_INSTITUTION_CONSTRAINTS',
  SET_INSTITUTION_CONSTRAINTS: 'SET_INSTITUTION_CONSTRAINTS',
  SET_INSTITUTION_CONSTRAINTS_LOADING: 'SET_INSTITUTION_CONSTRAINTS_LOADING',
  UPDATE_INSTITUTION_CONSTRAINT: 'UPDATE_INSTITUTION_CONSTRAINTS'
}
